// src/VerifyEmail.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function VerifyEmail() {
  const query = useQuery();
  const token = query.get('token');
  const [message, setMessage] = useState('Vérification en cours...');
  const [showManualLink, setShowManualLink] = useState(false);
//const [verifiedMessage, setVerifiedMessage] = useState(null);
 const [isError, setIsError] = useState(false);
const { t } = useTranslation();

  useEffect(() => {
  if (!token) {
    setMessage('Token de vérification manquant.');
    setShowManualLink(true); // toujours afficher le bouton
    return;
  }

  async function verify() {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/verify/verifyemail?token=${token}`
      );

      const code = res?.data?.code;
      const langFromServer = res?.data?.lang;

      if (langFromServer) {
        const onLangReady = () => {
          setMessage(t(code));
          i18n.off('languageChanged', onLangReady);
        };
        i18n.on('languageChanged', onLangReady);
        i18n.changeLanguage(langFromServer);
      } else {
        setMessage(t(code));
      }
    } catch (err) {
      console.error("Erreur lors de la vérification :", err.response?.data || err.message);
      setMessage('Erreur lors de la vérification de l\'email.');
   // } finally {
      // Toujours afficher le bouton, même en cas d'erreur
      //setShowManualLink(true);
    }
  }

  verify();
}, [token, t]);


 return (
  <div style={{ padding: '20px', fontFamily: 'Arial', textAlign: 'center' }}>
{!isError && (
    <h2>{t('verifemail.confirmedtitle')}</h2>
  )}
 {!isError && (
 
    <p style={{ marginTop: '20px', fontWeight: 'bold' }}>
      {t('verifemail.confirmedtexte')} {/* ex: "Ouvrez maintenant l’application et connectez-vous." */}
    </p>
  )}
  </div>
);

}

export default VerifyEmail;
